// extracted by mini-css-extract-plugin
export default {"container":"Variant_container__ew6xs","cell":"Variant_cell__DyMNz","pattern":"Variant_pattern__K1Lh3"};